import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../services/config";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { Paper } from "@material-ui/core";
import Select from "react-select";
function Firms() {
  const alert = useAlert();
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");
  const [loading, setloading] = useState(false);
  const [isallfields, setisallfields] = useState(false);

  const [firmsData, setFirmsData] = useState([]);
  const [campusesData, setCampusesData] = useState(user.campuses || []);
  const [subAccountData, setSubAccountData] = useState({
    label: "Select Account",
    value: "",
  });
  const [firmLoading, setFirmLoading] = useState(false);
  const [assignCampuses, setAssignCampuses] = useState(false);

  const [firmModal, setFirmModal] = useState("");
  const [firmName, setFirmName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [iban, setIban] = useState("");
  const [merchantName, setMerchantName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [terminalId, setTerminalId] = useState("");
  const [subAccountId, setSubAccountId] = useState([]);
  const [firmId, setFirmId] = useState("");
  const [campusIds, setCampusIds] = useState([]);

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteFirmId, setDeleteFirmId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    getFirms();
    getSubAccounts();
  }, []);

  const getFirms = async () => {
    setloading(true);
    await fetch(`${baseUrl}/firms`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setFirmsData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const getSubAccounts = () => {
    fetch(`${baseUrl}/subaccount`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [];
        console.log(data);
        data.payload.forEach((element) => {
          arr.push({
            label: element.title + `(${element.acode})`,
            value: element.id,
            account_chart_id: element.account_chart_id,
          });
        });
        setSubAccountData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const resetFormFields = () => {
    setFirmName("");
    setUsername("");
    setPassword("");
    setIban("");
    setMerchantName("");
    setMobileNo("");
    setTerminalId("");
    setSubAccountId([]);
    setCampusIds([]);
  };
  const addFirmHandler = async () => {
    if (
      firmName === "" ||
      username === "" ||
      password === "" ||
      iban === "" ||
      merchantName === "" ||
      mobileNo === "" ||
      terminalId === "" ||
      subAccountId === ""
    ) {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      firm_name: firmName,
      username: username,
      password: password,
      iban: iban,
      merchant_name: merchantName,
      mobile_no: mobileNo,
      terminal_id: terminalId,
      sub_account_id: subAccountId.value,
    };
    setFirmLoading(true);

    await fetch(`${baseUrl}/firms`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("Firm successfully added");
            setFirmModal("");
            setFirmLoading(false);
            getFirms();
            resetFormFields();
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setFirmModal("");
            setFirmLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setFirmModal("");
            setFirmLoading(false);
          }
        }),
      )
      .catch((err) => {
        setFirmLoading(false);
        setFirmModal("");
        console.log(err);
      });
  };

  const updateFirmHandler = async () => {
    if (
      firmName === "" ||
      username === "" ||
      password === "" ||
      iban === "" ||
      merchantName === "" ||
      mobileNo === "" ||
      terminalId === "" ||
      subAccountId === ""
    ) {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    setFirmLoading(true);
    const data = {
      firm_name: firmName,
      username: username,
      password: password,
      iban: iban,
      merchant_name: merchantName,
      mobile_no: mobileNo,
      terminal_id: terminalId,
      sub_account_id: subAccountId.value,
    };
    await fetch(`${baseUrl}/firms/${firmId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setFirmLoading(false);
          if (data.metadata.success) {
            alert.success("Firm Successfully Updated");
            getFirms();
            resetFormFields();
            setFirmModal("");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setFirmModal("");
          } else {
            alert.show("Something Went Wrong");
            setFirmModal("");
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setFirmLoading(false);
      });
  };

  const assignCampusHandler = async () => {
    if (campusIds.length === 0) {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    setFirmLoading(true);
    const data = {
      firm_id: firmId,
      campus_ids: campusIds.map((campus) => campus.value),
    };
    await fetch(`${baseUrl}/firm-campuses`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setFirmLoading(false);
          if (data.metadata.success) {
            alert.success("Firm Campuses Successfully Updated");
            getFirms();
            resetFormFields();
            setAssignCampuses("");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAssignCampuses("");
          } else {
            alert.show("Something Went Wrong");
            setAssignCampuses("");
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setFirmLoading(false);
      });
  };

  const deleteFirmHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/firms/${deleteFirmId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success("Firm Campuses Successfully Deleted");
            getFirms();
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            onClick={() => setFirmModal("add")}
            className="btn btn-primary mr-2"
          >
            Add Firm
          </button>
        </div>

        <div className="table-responsive">
          <Table
            className="mt-5"
            style={{ minWidth: "170%", overflow: "scroll" }}
          >
            <thead>
              <tr className="text-center">
                <th>SrNo.</th>
                <th>Firm Name</th>
                <th>Assign Campuses</th>
                <th>Username</th>
                <th>Password</th>
                <th>IBAN</th>
                <th>Merchant Name</th>
                <th>Mobile No</th>
                <th>Terminal ID</th>
                <th>Sub Account ID</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {firmsData?.map((firm, index) => (
                <tr className="text-center" key={index}>
                  <td>{index + 1}</td>
                  <td>{firm.firm_name}</td>
                  <td>
                    {firm.campuses?.length === 0 ? (
                      <span className="badge bg-light text-warning border fs-6">
                        No Campuses Assigned
                      </span>
                    ) : (
                      <div className="d-flex flex-wrap gap-1">
                        {firm.campuses?.map((campus, index) => (
                          <span
                            key={index}
                            className="badge bg-light text-color-primary border fs-6"
                          >
                            {campus?.name}
                          </span>
                        ))}
                      </div>
                    )}
                  </td>
                  <td>{firm.username}</td>
                  <td>{firm.password}</td>
                  <td>{firm.iban}</td>
                  <td>{firm.merchant_name}</td>
                  <td>{firm.mobile_no}</td>
                  <td>{firm.terminal_id}</td>
                  <td>{firm.sub_account?.title}</td>
                  <td>
                    <a
                      className="btn btn-icon btn-light btn-hover-primary-custom btn-sm"
                      onClick={() => {
                        setFirmId(firm?.id);
                        setAssignCampuses(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Navigation/Plus.svg",
                          )}
                        />
                      </span>
                    </a>

                    <a
                      className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                      onClick={() => {
                        setFirmId(firm?.id);
                        setFirmName(firm?.firm_name);
                        setUsername(firm?.username);
                        setPassword(firm?.password);
                        setIban(firm?.iban);
                        setMerchantName(firm?.merchant_name);
                        setMobileNo(firm?.mobile_no);
                        setTerminalId(firm?.terminal_id);
                        setSubAccountId(
                          subAccountData.find(
                            (subAccount) =>
                              subAccount.value === firm?.sub_account_id,
                          ),
                        );
                        setFirmModal("edit");
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Write.svg",
                          )}
                        />
                      </span>
                    </a>

                    <a
                      className="btn btn-icon btn-light btn-hover-danger btn-sm"
                      onClick={() => {
                        setDeleteFirmId(firm?.id);
                        setdeleteModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-danger">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Delete-user.svg",
                          )}
                        />
                      </span>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        {/* Add Firm Modal */}
        <Modal show={firmModal === "add" || firmModal === "edit"} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              {firmModal === "add" ? "Add New Firm" : "Update Firm"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Firm Name <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control text-uppercase"
                  value={firmName}
                  onChange={(e) => setFirmName(e.target.value)}
                  placeholder="Enter Firm Name"
                />
              </div>

              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Username <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control text-uppercase"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter Username"
                />
              </div>

              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Password <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  type="password"
                  className="form-control text-uppercase"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter Password"
                />
              </div>

              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter IBAN <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control text-uppercase"
                  value={iban}
                  onChange={(e) => setIban(e.target.value)}
                  placeholder="Enter IBAN"
                />
              </div>

              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Merchant Name <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control text-uppercase"
                  value={merchantName}
                  onChange={(e) => setMerchantName(e.target.value)}
                  placeholder="Enter Merchant Name"
                />
              </div>

              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Mobile No. <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control text-uppercase"
                  value={mobileNo}
                  onChange={(e) => setMobileNo(e.target.value)}
                  placeholder="Enter Mobile No."
                />
              </div>

              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Enter Terminal ID <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control text-uppercase"
                  value={terminalId}
                  onChange={(e) => setTerminalId(e.target.value)}
                  placeholder="Enter Terminal ID"
                />
              </div>

              <div className="col-md-6">
                <label className="form-control-label">
                  <b>
                    Select Sub Account <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <Select
                  value={subAccountId}
                  onChange={(e) => setSubAccountId(e)}
                  className="disselect"
                  placeholder="Select Account"
                  options={subAccountData}
                />
              </div>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {firmLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : firmModal === "add" ? (
              <button
                className="btn btn-success button_blue"
                onClick={addFirmHandler}
              >
                Add
              </button>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={updateFirmHandler}
              >
                Update
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setFirmModal("");
                setisallfields(false);
                resetFormFields();
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/*Assign Campuses Modal */}
        <Modal show={assignCampuses} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Assign Campuses
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Select Campuses <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <Select
                value={campusIds}
                onChange={(e) => setCampusIds(e)}
                className="disselect"
                placeholder="Select Campuses"
                options={campusesData.map((campus) => ({
                  label: campus.name,
                  value: campus.id,
                }))}
                isMulti
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            {firmLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button onClick={assignCampusHandler} className="btn btn-primary">
                Assign
              </button>
            )}

            <button
              onClick={() => setAssignCampuses(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Firm Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this firm?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Firm Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button onClick={deleteFirmHandle} className="btn button_blue">
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default Firms;
